import React from "react";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import __ from "lodash";

import LoaderModal from "../../../modal/LoaderModal";
import Navbar from "../../navbar/Navbar";
import Sidebar from "../../sidebar/Sidebar";
import Alert from "@material-ui/lab/Alert";
import env from "react-dotenv";

class SiswaUrl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            urlSiswa: env.REACT_APP_URL_SISWA_FE + "/registersk.html?",
            copySuccess: "",
        };
    }

    async componentDidMount() {
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
        }
    }

    copyToClipboard = (e) => {
        this.textArea.select();
        document.execCommand("copy");
        // This is just personal preference.
        // I prefer to not show the whole text area selected.
        e.target.focus();
        this.setState({ copySuccess: "Copied!" });
    };

    render() {
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar />
                    <div className="row">
                        <div className="col-md-12">
                            <h4>Url Registrasi Siswa Mandiri</h4>
                        </div>
                    </div>
                    {this.loadAlert()}
                    <div className="row">
                        <div className="col-md-12">
                            <form>
                                <input className="form-control" ref={(textarea) => (this.textArea = textarea)} value={this.state.urlSiswa + this.props.account.idSekolah} />
                            </form>
                            <br />
                            {document.queryCommandSupported("copy") && (
                                <div>
                                    <button className="btn btn-outline-danger" onClick={this.copyToClipboard}>
                                        Copy URL
                                    </button>
                                    &nbsp;{this.state.copySuccess}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    loadAlert = () => {
        const { alertShow, resMessage } = this.state;

        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{resMessage.errorMessage}</strong>
                </Alert>
            );
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(SiswaUrl);
